<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col cols="12" lg="6">
        <div class="form-group">
          <label
                  for="excmsla_title"
                  class="form-control-label">{{$t('views.excmsla.form.title')}}:</label>
          <input
                  id="excmsla_title"
                  v-model="item.title"
                  :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('title', $event.target.value)">
          <div
                  v-if="isInvalid('title')"
                  class="invalid-feedback">{{ violations.title }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div class="form-group">
          <label
                  for="excmsla_symbol"
                  class="form-control-label">{{$t('views.excmsla.form.symbol')}}:</label>
          <input
                  id="excmsla_symbol"
                  v-model="item.symbol"
                  :class="['form-control', isInvalid('symbol') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('symbol', $event.target.value)">
          <div
                  v-if="isInvalid('symbol')"
                  class="invalid-feedback">{{ violations.symbol }}</div>
        </div>
      </b-col>
      <b-col cols="12">
        <div class="form-group">
          <label
                  for="excmsla_description"
                  class="form-control-label">{{$t('views.excmsla.form.description')}}:</label>
          <input
                  id="excmsla_description"
                  v-model="item.description"
                  :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('description', $event.target.value)">
          <div
                  v-if="isInvalid('description')"
                  class="invalid-feedback">{{ violations.description }}</div>
        </div>
      </b-col>
      <b-col cols="12" lg="4">
        <b-row>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_reactionTime"
                      class="form-control-label">{{$t('views.excmsla.form.reactionTime')}}:</label>
              <input
                      id="excmsla_reactionTime"
                      v-model="item.reactionTime"
                      :class="['form-control', isInvalid('reactionTime') ? 'is-invalid' : '']"
                      type="number"
                      placeholder=""
                      @input="handleUpdateField('reactionTime', $event.target.value)">
              <div
                      v-if="isInvalid('reactionTime')"
                      class="invalid-feedback">{{ violations.reactionTime }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_reactionTimeUnit"
                      class="form-control-label">{{$t('views.excmsla.form.timeUnit')}}:</label>
              <fg-input :error="violations.reactionTimeUnit">
                <el-select
                        id="excmsla_reactionTimeUnit"
                        :class="['select-default', isInvalid('reactionTimeUnit') ? 'select-danger' : '']"
                        filterable
                        v-model="item.reactionTimeUnit">
                  <el-option v-for="option in timeUnits"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('reactionTimeUnit')"
                      class="invalid-feedback">{{ violations.reactionTimeUnit }}</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="4">
        <b-row>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_bypassTime"
                      class="form-control-label">{{$t('views.excmsla.form.bypassTime')}}:</label>
              <input
                      id="excmsla_bypassTime"
                      v-model="item.bypassTime"
                      :class="['form-control', isInvalid('bypassTime') ? 'is-invalid' : '']"
                      type="number"
                      placeholder=""
                      @input="handleUpdateField('bypassTime', $event.target.value)">
              <div
                      v-if="isInvalid('bypassTime')"
                      class="invalid-feedback">{{ violations.bypassTime }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_bypassTimeUnit"
                      class="form-control-label">{{$t('views.excmsla.form.timeUnit')}}:</label>
              <fg-input :error="violations.bypassTimeUnit">
                <el-select
                        id="excmsla_bypassTimeUnit"
                        :class="['select-default', isInvalid('bypassTimeUnit') ? 'select-danger' : '']"
                        filterable
                        v-model="item.bypassTimeUnit">
                  <el-option v-for="option in timeUnits"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('bypassTimeUnit')"
                      class="invalid-feedback">{{ violations.bypassTimeUnit }}</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" lg="4">
        <b-row>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_repairTime"
                      class="form-control-label">{{$t('views.excmsla.form.repairTime')}}:</label>
              <input
                      id="excmsla_repairTime"
                      v-model="item.repairTime"
                      :class="['form-control', isInvalid('repairTime') ? 'is-invalid' : '']"
                      type="number"
                      placeholder=""
                      @input="handleUpdateField('repairTime', $event.target.value)">
              <div
                      v-if="isInvalid('repairTime')"
                      class="invalid-feedback">{{ violations.repairTime }}</div>
            </div>
          </b-col>
          <b-col cols="12" lg="6">
            <div class="form-group">
              <label
                      for="excmsla_repairTimeUnit"
                      class="form-control-label">{{$t('views.excmsla.form.timeUnit')}}:</label>
              <fg-input :error="violations.repairTimeUnit">
                <el-select
                        id="excmsla_repairTimeUnit"
                        :class="['select-default', isInvalid('repairTimeUnit') ? 'select-danger' : '']"
                        filterable
                        v-model="item.repairTimeUnit">
                  <el-option v-for="option in timeUnits"
                             class="select-default"
                             :value="option.value"
                             :label="option.text"
                             :key="option.value">
                  </el-option>
                </el-select>
              </fg-input>
              <div
                      v-if="isInvalid('repairTimeUnit')"
                      class="invalid-feedback">{{ violations.repairTimeUnit }}</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <button
      type="submit"
      class="btn btn-success">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  data () {
    return {
      timeUnits: [
        { value: 1, text: this.$t('global.timeMeasures.minutes') },
        { value: 2, text: this.$t('global.timeMeasures.hours') },
        { value: 3, text: this.$t('global.timeMeasures.days') },
        { value: 4, text: this.$t('global.timeMeasures.workDays') },
        { value: 5, text: this.$t('global.timeMeasures.workHours') }
      ]
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
